import { SectionThemeProvider } from "@trustpilot/businessapp-patternlibrary";
import React from "react";
import OutsideClickHandler from "react-outside-click-handler";

import { useMediaQuery } from "../../../utils/helpers";
import { StyledMenuWrapper, StyledMenuIconWrapper, StyledMenuIcon, StyledMenuContent } from "./styled";
import * as Types from "./types";

const Menu: React.FC<Types.Menu> = ({ children, target, toggle, toggled, hideOnMobile, testid, id }) => {
  const iconRef = React.useRef(null);
  const onOutsideClick = ({ target }) => {
    if (!iconRef.current.contains(target)) {
      toggle();
    }
  };

  const isDesktop = useMediaQuery("(min-width: 768px)");

  const icon = (
    <StyledMenuIconWrapper ref={iconRef} onClick={toggle}>
      <StyledMenuIcon data-testid={testid}>{target}</StyledMenuIcon>
    </StyledMenuIconWrapper>
  );

  return (
    <StyledMenuWrapper hideOnMobile={hideOnMobile}>
      {isDesktop ? icon : <SectionThemeProvider theme="dark-green">{icon}</SectionThemeProvider>}
      {toggled && (
        <OutsideClickHandler onOutsideClick={onOutsideClick}>
          <StyledMenuContent id={id}>{children}</StyledMenuContent>
        </OutsideClickHandler>
      )}
    </StyledMenuWrapper>
  );
};

export default Menu;
